export default __webpack_public_path__ + "static/media/stampLogo.755c235f.svg";